import z from "zod";
import { WHITELISTED_SPORTS, WINNING_OUTCOME_ID_MAGIC_ABSENT, WINNING_OUTCOME_ID_MAGIC_EVENT_CANCELLED, WINNING_OUTCOME_ID_MAGIC_EXACT_HIT, WINNING_OUTCOME_ID_MAGIC_MAJOR_RESCHEDULE, WINNING_OUTCOME_ID_MAGIC_NONE } from "./config";

export * from "./odds-plain-schemas"

export const SettledStatValueSchema = z.number()

export const WinningOutcomeIdSchema = z.union([
	z.string(),
	z.literal(WINNING_OUTCOME_ID_MAGIC_ABSENT),
	z.literal(WINNING_OUTCOME_ID_MAGIC_EXACT_HIT),
	z.literal(WINNING_OUTCOME_ID_MAGIC_EVENT_CANCELLED),
	z.literal(WINNING_OUTCOME_ID_MAGIC_NONE),
	z.literal(WINNING_OUTCOME_ID_MAGIC_MAJOR_RESCHEDULE),
])

export const EventStatusSchema = z.enum([
	"live",
	"half",
	"unplayed",
	"completed",
	"cancelled",
	"suspended",
	"delayed",
]);

export const SportKeySchema = z.enum(WHITELISTED_SPORTS);

export const BetPickSchema = z.object({
	event_market_onchain_id: z.string(),
	outcome_onchain_id: z.string(),
})

const BetIntentBaseSchema = z.object({
	picks: z.array(BetPickSchema),
	size_raw: z.string(),
	wallet_nonce: z.number().int().nonnegative(),
	initiator_signature: z.string(),
	owner_wallet_address: z.string(),
	contract_address: z.string(),
	chain_id: z.number(),
	deadline_ts: z.number().int().nonnegative(),
	token_type: z.number().int().nonnegative().max(1),
});

export const BetIntentPowerplaySchema = BetIntentBaseSchema.merge(z.object({
	type: z.literal("powerplay"),
	combo_multipliers_config_onchain_id: z.string(),
}));
export const BetIntentFlexplaySchema = BetIntentBaseSchema.merge(z.object({
	type: z.literal("flexplay"),
	flex_combo_multipliers_config_onchain_id: z.string(),
}));

export const BetIntentSchema = z.discriminatedUnion("type", [
	BetIntentPowerplaySchema,
	BetIntentFlexplaySchema,
]);

export const ChainSchema = z.object({
	id: z.number().int().positive(),
	min_safe_confimations: z.number().int().nonnegative(),
});


export const BetStatusSchema = z.enum(["active", "settled", "canceled", "refunded", "frozen", "seized"]);


export const BetTypeSchema = z.enum(["powerplay", "flexplay"]);


export const PrizepicksEnhancingTagSchema = z.enum(["demon", "goblin"]);
export const EnhancingTagSchema = z.enum(["lit", "ice"]);
